export default __webpack_public_path__ + "static/media/orbis.4d994878.png";